import { render, staticRenderFns } from "./h1_volatility.vue?vue&type=template&id=5990631f&"
import script from "./h1_volatility.vue?vue&type=script&lang=js&"
export * from "./h1_volatility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports